import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAuth();
  }

  // Sin sesion (o con el token vencido / ilegible) devuelve un UrlTree al login: el router
  // cancela la navegacion en curso y redirige en UN paso. Antes hacia navigate() + return false,
  // que son dos navegaciones compitiendo (re-scan de seguridad, "Route guard redirect").
  private checkAuth(): boolean | UrlTree {
    const token = localStorage.getItem('token');
    if (!token) {
      return this.router.createUrlTree(['/login']);
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp && payload.exp * 1000 < Date.now()) {
        localStorage.removeItem('token');
        return this.router.createUrlTree(['/login']);
      }
    } catch (e) {
      localStorage.removeItem('token');
      return this.router.createUrlTree(['/login']);
    }

    return true;
  }
}
